export const YANDEX_METRIKA_ID = 89370833;
export const MY_TRACKER_ID = '3247888';
export const GOOGLE_ANALYTICS_ID = 'G-3R5JQM4WFB';
